import { EmptyState } from "@flexfreight/ui";
import { useLocation } from "react-router";
import { navItemFor } from "../shell/nav";

/** Honest placeholder for modules that are not built yet (ADMIN_PROGRESS.md tracks their status). */
export function Placeholder() {
  const { pathname } = useLocation();
  const label = navItemFor(pathname)?.label ?? "This page";
  return (
    <section className="ffa-page">
      <h1 className="ffa-page__title">{label}</h1>
      <EmptyState title="Not built yet" body={`${label} is on the build plan and isn't available in this version of the console.`} />
    </section>
  );
}

export function NotFound() {
  return (
    <section className="ffa-page">
      <h1 className="ffa-page__title">Page not found</h1>
      <EmptyState title="Nothing here" body="Check the address, or pick a page from the navigation." />
    </section>
  );
}
